import { Modal, Typography } from "antd";
import React from "react";

const DialogSubmitCashCountToLogout = ({ open, close }) => {
  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      //   closable={false}
      footer={null}
      width={350}
      centered
    >
      <Typography style={{ fontWeight: "bold", color: "red", fontSize: 18 }}>
        Notice:
      </Typography>
      <Typography style={{ fontWeight: "bold", fontSize: 16 }}>
        Please update your daily cash count first before you logout.
      </Typography>
    </Modal>
  );
};

export default DialogSubmitCashCountToLogout;
